module.exports = __webpack_public_path__ + "img/list-item-default.2453d5b0.svg";